import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from 'src/shared/components/ui/popups/dropdown-menu'

import MarkAllAsReadButton from '../components/mark-all-as-read-button'
import AllNotificationsView from '../views/all-notifications-view'

interface AllNotificationsModalProps {
  trigger: React.ReactNode
  open?: boolean
  onOpenChange?: (open: boolean) => void
}

const AllNotificationsModal = ({ trigger, open, onOpenChange }: AllNotificationsModalProps) => {
  return (
    <DropdownMenu open={open} onOpenChange={onOpenChange}>
      <DropdownMenuTrigger>{trigger}</DropdownMenuTrigger>
      <DropdownMenuContent
        sideOffset={6}
        align="end"
        className="flex max-h-[80vh] min-h-[320px] w-[480px] flex-col rounded-[20px] border border-lightBorder bg-white p-0 shadow-[0_0px_25px_rgba(27,48,41,0.2)]"
      >
        <div className="flex flex-1 flex-col">
          <div className="flex flex-row items-center justify-between p-5 pt-8">
            <h1 className="text-[26px] font-semibold leading-tight tracking-[-0.25px] text-primary">Activity</h1>
            <MarkAllAsReadButton />
          </div>
          <AllNotificationsView />
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default AllNotificationsModal
